<template>
    <!--
        Half-month chooser for DateRangePicker: browse months and pick the 1st
        to the 15th or the 16th to the end of the month. Emits `select` with
        { start, end } as luxon DateTimes.
    -->
    <div>
        <date-range-nav class="mb-6"
                        :title="view.toFormat('LLLL yyyy')"
                        :next-disabled="isAfterMax(view.plus({ months: 1 }))"
                        @prev="view = view.minus({ months: 1 })"
                        @next="view = view.plus({ months: 1 })"
        ></date-range-nav>
        <div    class="flex flex-col gap-2">
            <button v-for="half in halves"
                    :key="half.half"
                    type="button"
                    class="rounded-md px-3 py-2.5 text-left text-base disabled:cursor-not-allowed disabled:opacity-40"
                    :class="isSelected(half.half) ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                    :disabled="isAfterMax(halfRange(half.half).start)"
                    @click="$emit('select', halfRange(half.half))"
            >{{ half.label }}</button>
        </div>
    </div>
</template>

<script>
import { halfMonthRange } from '../../../utils/dateRangePresets'
import DateRangeNav from './DateRangeNav.vue'

export default {
    name: 'DateRangeHalfMonthPane',
    components: { DateRangeNav },
    emits: ['select'],
    props: {
        // luxon DateTimes; the pane opens on the month of `start`.
        start: {
            type: Object,
            default: null,
        },
        today: {
            type: Object,
            required: true,
        },
        // Last selectable day, or null for no limit.
        maxDate: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            halves: [
                { half: 1, label: '1st – 15th' },
                { half: 2, label: '16th – end of month' },
            ],
            // First of the month being shown.
            view: (this.start ?? this.today).startOf('month'),
        }
    },
    watch: {
        // Follow a selection made outside the pane (a preset click, v-model).
        start(start) {
            if (start && !start.hasSame(this.view, 'month')) {
                this.view = start.startOf('month')
            }
        },
    },
    methods: {
        halfRange(half) {
            return halfMonthRange(this.view.year, this.view.month, half)
        },
        isSelected(half) {
            if (!this.start || !this.start.hasSame(this.view, 'month')) {
                return false
            }
            return (half === 1) ? (this.start.day === 1) : (this.start.day === 16)
        },
        isAfterMax(date) {
            return !!this.maxDate && (date > this.maxDate)
        },
    },
}
</script>
